import React, { useContext, useEffect, useState } from "react";

import CheckIcon from "@mui/icons-material/Check";
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Card } from "react-bootstrap";
import PsContext from "../../context";
import {
  _ONLINE_TRANSPORT_LIST,
  _SAVE_TRANSPORT_PREFERENCE,
} from "../../models/studentModel";
import { MuiConfirmWindow } from "../../utils";
import Header from "../header";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const TransportRequest = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const [transportList, setTransportList] = useState([]);
  const [viewData, setViewData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    context.setLoader(true);
    _ONLINE_TRANSPORT_LIST().then((res) => {
      if (res.status == "1") {
        setTransportList(res.data);
      } else {
        setTransportList([]);
      }
      context.setLoader(false);
    });
  };

  const linkClick = (item) => {
    setViewData(item);
    setConfirm(true);
  };

  const onConfirm = () => {
    context.setLoader(true);
    _SAVE_TRANSPORT_PREFERENCE({
      vehicle_id: viewData.vehicle_id,
      destination_id: viewData.id,
    }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Saved");
        loadData();
      } else {
        context.setAlertMsg(res.message || "Error");
        context.setLoader(false);
      }
    });
  };

  return (
    <>
      <Header title="Transport Request" backAction={[]} rightActions={[]} />

      <div className="container-sm py-md-3">
        <Card>
          <Card.Header className="card-header-bg text-uppercase fw-bold">
            Select your Destination
          </Card.Header>
          <Card.Body className="p-0">
            <List>
              {transportList.map((item, i) => {
                return (
                  <>
                    <ListItem
                      className={
                        item.id == item.selected_destination_id && "bg-green-50"
                      }
                    >
                      <ListItemText
                        primary={item.destination_name}
                        secondary={
                          <>
                            {item.vehicle_no} - College To {item.vehicle_route}
                          </>
                        }
                      />
                      {!item.selected_destination_log_id && (
                        <IconButton edge="end" onClick={(e) => linkClick(item)}>
                          <ArrowForwardIosIcon />
                        </IconButton>
                      )}
                      {item.id == item.selected_destination_id && (
                        <IconButton edge="end">
                          <CheckIcon />
                        </IconButton>
                      )}
                    </ListItem>
                    <Divider />
                  </>
                );
              })}
            </List>
          </Card.Body>
        </Card>
      </div>

      <MuiConfirmWindow
        open={confirm}
        onClose={(e) => {
          setViewData([]);
          setConfirm(false);
        }}
        title="Confirm"
        cancelText="Cancel"
        okText="Confirm"
        onSuccess={(e) => {
          setConfirm(false);
          onConfirm();
        }}
      >
        Would you like to save the selected Destination as your preferred
        option?
        <br />
        Once confirmed, your preference cannot be changed.
      </MuiConfirmWindow>
    </>
  );
};
export default TransportRequest;
